(function () {
  'use strict';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var visible = new Set();
  var media = document.querySelectorAll('[data-fd-banner], iframe[data-fd-src]');
  function play(video) {
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {
      if (video.dataset.fdManual === 'true') setBannerRequested(video, false);
    });
  }
  function setBannerRequested(video, requested) {
    video.dataset.fdRequested = String(requested);
    var button = video.closest('.product-banner').querySelector('[data-fd-banner-toggle]');
    if (button) {
      button.setAttribute('aria-pressed', String(requested));
      button.textContent = requested ? button.dataset.pauseLabel : button.dataset.playLabel;
    }
  }
  var nearbyReviews = new Set();
  function loadFrame(element) {
    if (document.hidden || element.getAttribute('src')) return;
    var url = new URL(element.dataset.fdSrc);
    url.searchParams.set('autoplay', '0');
    url.searchParams.set('background', '0');
    url.searchParams.set('controls', reducedMotion.matches ? '1' : '0');
    url.searchParams.set('title', '0');
    url.searchParams.set('byline', '0');
    url.searchParams.set('portrait', '0');
    url.searchParams.set('preload', 'auto');
    element.loading = 'eager';
    element.src = url.href;
  }
  function warmReviews(rail) {
    rail.querySelectorAll('iframe[data-fd-src]').forEach(loadFrame);
  }
  function update(element) {
    var active = visible.has(element) && !document.hidden;
    if (element.tagName === 'VIDEO') {
      var manual = element.dataset.fdManual === 'true';
      var requested = element.dataset.fdRequested === 'true';
      if (!active || element.dataset.fdModalPaused === 'true' || (manual && !requested) || (!manual && (reducedMotion.matches || (navigator.connection && navigator.connection.saveData)))) {
        element.pause();
        return;
      }
      if (!element.getAttribute('src')) {
        element.src = window.matchMedia('(max-width: 749px)').matches ? element.dataset.fdMobile : element.dataset.fdDesktop;
      }
      play(element);
    } else {
      if (active) loadFrame(element);
      if (element.getAttribute('src') && element.contentWindow) {
        element.contentWindow.postMessage(JSON.stringify({ method: active && !reducedMotion.matches ? 'play' : 'pause' }), 'https://player.vimeo.com');
      }
    }
  }
  media.forEach(function (element) {
    element.addEventListener('load', function () { update(element); });
    if (element.tagName !== 'VIDEO' || element.dataset.fdManual !== 'true') return;
    var button = element.closest('.product-banner').querySelector('[data-fd-banner-toggle]');
    if (element.dataset.fdAutoplay === 'true') {
      setBannerRequested(element, !reducedMotion.matches && !(navigator.connection && navigator.connection.saveData));
    }
    if (!button) return;
    button.hidden = false;
    button.addEventListener('click', function () {
      setBannerRequested(element, element.dataset.fdRequested !== 'true');
      visible.add(element);
      update(element);
    });
  });
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://player.vimeo.com') return;
    var data;
    try { data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; } catch (_) { return; }
    if (!data || data.event !== 'ready') return;
    media.forEach(function (element) { if (element.contentWindow === event.source) update(element); });
  });
  function observe() {
    if ('IntersectionObserver' in window) {
      var preloadObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            nearbyReviews.add(entry.target);
            warmReviews(entry.target);
          } else nearbyReviews.delete(entry.target);
        });
      }, { rootMargin: '600px 0px', threshold: 0 });
      document.querySelectorAll('.ugc-loop__rail').forEach(function (rail) {
        preloadObserver.observe(rail);
      });
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.2) visible.add(entry.target);
          else visible.delete(entry.target);
          update(entry.target);
        });
      }, { threshold: [0, 0.2] });
      media.forEach(function (element) { observer.observe(element); });
    } else {
      media.forEach(function (element) { visible.add(element); update(element); });
    }
  }
  // Let the product photo finish before optional animation competes for bandwidth.
  var firstPhoto = document.querySelector('#gallery-track img[fetchpriority="high"]');
  var photoReady = firstPhoto && firstPhoto.decode ? firstPhoto.decode().catch(function () {}) : Promise.resolve();
  photoReady.then(observe);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) nearbyReviews.forEach(warmReviews);
    media.forEach(update);
    document.querySelectorAll('.product-gallery__video').forEach(function (video) {
      if (document.hidden) video.pause();
      else if (video.dataset.fdActive === 'true') play(video);
    });
  });
  reducedMotion.addEventListener('change', function () { media.forEach(update); });
})();
